import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import PaintPaletteIcon from '@atlaskit/icon/core/paint-palette';
import { token } from '@atlaskit/tokens';

const messages = defineMessages({
	iconLabel: {
		id: 'update-work-item-all-fields-action-renderer.ui.action-card.jira-color-field.icon-label',
		defaultMessage: 'Color field icon',
		description:
			'Accessible label for the icon representing the color field in a Jira work item action card.',
	},
});

export function ColorFieldIcon(): React.JSX.Element {
	const { formatMessage } = useIntl();
	return (
		<PaintPaletteIcon
			label={formatMessage(messages.iconLabel)}
			size="small"
			color={token('color.icon.subtle')}
		/>
	);
}
